import { GoogleApiWrapper, InfoWindow, Map as GMaps, Marker } from 'google-maps-react';
import queryString from 'query-string';
import React from 'react';
import * as traceability_service from '../../domain/services/merchant_trace_service';
import logo from '../img/hortify-preto.png';
import './App.css';

class MerchantTraceability extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            product: null,
            retail: '',
            retailsList: null,
            retailsSelectList: null,
            showingInfoWindow: false,  //Hides or the shows the infoWindow
            activeMarker: {},          //Shows the active marker upon click
            selectedPlace: {},
            initialCenter: null,
            showForm: false,
            showRetails: false,
            traceabilityCode: ''
        };
    }

    componentDidMount() {
        const search = queryString.parse(this.props.search)
        this.loadMerchantTrace(search);
    }

    render() {
        const showForm = this.state.showForm;
        const showRetails = this.state.showRetails;
        const retailsSelectList = this.state.retailsSelectList;
        const productTraceability = this.state.product;
        const search = queryString.parse(this.props.search)

        const isUrlOk = search.m != null;
        const isLoading = productTraceability === null;

        if (!isUrlOk)
            return <p>Url inválida</p>

        if (isLoading && !showForm && !showRetails)
            return <p>Carregando...</p>

        if (showForm) {
            return this.traceabilityCodeField()
        }

        if (showRetails && retailsSelectList != null) {
            return this.retailsSelectOptions(retailsSelectList)
        }

        if (!isLoading && productTraceability.traceabilityCode != null)
            return (
                <div className="container">
                    <div className="panel panel-default">
                        <div className="panel-heading">
                            <h3 className="panel-title">
                                <img src={logo} alt="Logo" style={{ marginTop: 0.5 + 'em' }} width='222px' />
                            </h3>
                        </div>

                        {this.cultiveComponents(productTraceability)}

                        <div className="row" style={{ marginTop: 1.5 + 'em' }}>
                            {this.producerComponents(productTraceability)}
                            {this.merchantComponents(productTraceability)}
                            {this.retailComponents(productTraceability)}
                        </div>

                        {this.displayMaps()}
                    </div>
                </div>
            );
        else
            return <p>Código inválido!</p>
    }


    loadMerchantTrace = (search) => {
        if (search.m != null && search.d != null) {
            traceability_service.fetchMerchantProductTraceability(search.m, search.d, (data) => {
                if (data != null)
                    this.setState({
                        product: data,
                        initialCenter: { lat: data.merchantLat, lng: data.merchantLong }
                    })
                else {
                    this.setState({
                        product: {}
                    })
                }
            });
        } else
            if (search.m != null && search.c != null) {
                traceability_service.fetchMerchantCultiveTraceability(search.m, search.c, (data) => {
                    if (data != null) {
                        const distinctRetailList = [];
                        const map = new Map();
                        for (const item of data.docs) {
                            if (!map.has(item.data().customerId)) {
                                map.set(item.data().customerId, true);    // set any value to Map
                                distinctRetailList.push({
                                    customerId: item.data().customerId,
                                    customerName: item.data().customerName
                                });
                            }
                        }

                        this.setState({
                            retailsList: data.docs,
                            retailsSelectList: distinctRetailList,
                            showRetails: true,
                        })
                    }
                    else {
                        this.setState({
                            retailsList: null,
                        })
                    }
                });

            } else
                if (search.m != null) {
                    this.setState({
                        showForm: true,
                    })
                }
    }

    traceabilityCodeField = () => {
        return <div style={{ marginTop: 5.5 + 'em' }}>
            <div className="text-center">
                <img src={logo} alt="Logo" style={{ marginTop: 0.5 + 'em' }} width='222px' />
            </div>

            <div className="text-center">
                <label>
                    Por favor informe o código de rastreabilidade localizado na embalagem
          </label>
            </div>
            <div className="row justify-content-center m-top">
                <div className="col-sm-4">
                    <input className="form-control" value={this.state.traceabilityCode} onChange={this.handleTraceabilityCodeChange} type="text" />
                </div>
            </div>

            <div className="text-center m-top">
                <input type="button" className="btn btn-success" onClick={this.handleSubmit} value="Buscar" />
            </div>
        </div>
    }

    retailsSelectOptions = (retailsSelectList) => {
        return <div style={{ marginTop: 5.5 + 'em' }}>
            <div className="text-center">
                <img src={logo} alt="Logo" style={{ marginTop: 0.5 + 'em' }} width='222px' />
            </div>

            <div className="text-center">
                <label>
                    Por favor selecione o local onde o produto foi adquirido
                </label>
            </div>
            <div className="row justify-content-center m-top">
                <div className="col-sm-12 text-center">
                    <select value={this.state.retail} onChange={this.onRetailChanged}>
                        <option key='none' value='none'>Selecione</option>
                        {retailsSelectList.map((entry) =>
                            <option key={entry.customerId} value={entry.customerId}>{entry.customerName}</option>
                        )}
                    </select>
                </div>
            </div>
        </div>
    }

    cultiveComponents = (productTraceability) => {
        const plantingDates = productTraceability.products.map((product) => this.formatDate(new Date(product.plantingDate))).join(', ');

        return <div className="panel-heading">
            <h3 className="panel-title">
                {productTraceability.merchantCultive} / Nr. lote: {productTraceability.lotNumber}
            </h3>
            {this.displayProductValidity(productTraceability)}
            <h6 className="panel-title">
                Cód. de Rastreabilidade: {productTraceability.traceabilityCode}
            </h6>
            <h6 className="panel-title">
                Data de Plantio: {plantingDates}
            </h6>
            {this.displayDataColheita(productTraceability)}
            {/* <h6 className="panel-title">
                Data de Transporte: {this.formatDate(new Date(productTraceability.dispatchDate))}
            </h6> */}
        </div>
    }

    producerComponents = (productTraceability) => {
        return <div className="col-sm-4" style={{ paddingLeft: 0 + 'em', marginBottom: 2 + 'em' }} >
            <div className="col-sm-12">
                <h4>Produtor</h4>
            </div>

            {productTraceability.products.map((production) =>
                <div>
                    <div className="col-sm-12">
                        {production.producer}
                    </div>
                    <div className="col-sm-12">
                        {production.producerState === null || production.producerState === ''
                            ? production.producerCity : production.producerCity + ' / ' + production.producerState}
                    </div>
                </div>
            )}
        </div>
    }

    merchantComponents = (productTraceability) => {
        const merchantCityState = productTraceability.merchantState === null || productTraceability.merchantState === ''
            ? productTraceability.merchantCity : productTraceability.merchantCity + ' / ' + productTraceability.merchantState;

        return <div className="col-sm-4" style={{ paddingLeft: 0 + 'em', marginBottom: 2 + 'em' }} >
            <div className="col-sm-12">
                <h4>Distribuidor</h4>
            </div>
            <div className="col-sm-12">
                {productTraceability.merchant}
            </div>
            <div className="col-sm-12">
                {merchantCityState}
            </div>
        </div>
    }

    retailComponents = (productTraceability) => {
        return <div className="col-sm-4" style={{ paddingLeft: 0 + 'em' }}>
            <div className="col-sm-12">
                <h4>Comerciante</h4>
            </div>
            <div className="col-sm-12">
                {productTraceability.customerName}
            </div>
            <div className="col-sm-12">
                {productTraceability.customerCity} / {productTraceability.customerState}
            </div>
        </div>
    }

    onClose = props => {
        if (this.state.showingInfoWindow) {
            this.setState({
                showingInfoWindow: false,
                activeMarker: {}
            });
        }
    };

    onMarkerClick = (props, marker, e) =>
        this.setState({
            selectedPlace: props,
            activeMarker: marker,
            showingInfoWindow: true
        });


    displayMarkers = () => {
        const productTraceability = this.state.product;
        const truck = { url: require("../img/caminhao.png") };
        const market = { url: require("../img/supermercado.png") };
        const farmer = { url: require("../img/trabalho.png") };

        const markers = [
            <Marker key={productTraceability.customerLat} icon={market} id={productTraceability.customerLat} name={productTraceability.customerName} position={{
                lat: productTraceability.customerLat,
                lng: productTraceability.customerLong
            }} onClick={this.onMarkerClick}>
            </Marker>,
            <Marker key={productTraceability.merchantLat} icon={truck} id={productTraceability.merchantLat} name={productTraceability.merchant} position={{
                lat: productTraceability.merchantLat,
                lng: productTraceability.merchantLong
            }} onClick={this.onMarkerClick}>
            </Marker>
        ];


        for (const production of productTraceability.products) {
            markers.push(
                <Marker key={production.producerLat} icon={farmer} id={production.producerLat} name={production.producer} position={{
                    lat: production.producerLat,
                    lng: production.producerLong
                }} onClick={this.onMarkerClick}>
                </Marker>
            )
        }
        return markers
    }

    displayMaps = () => {
        if (this.state.initialCenter != null) {

            const mapStyles = {
                width: '100%',
                height: '400px',
            };

            return <div className="row body" style={{ height: 28 + 'em', marginRight: 1 + 'em' }}>
                <div className="col-sm-12" >
                    <GMaps
                        google={this.props.google}
                        zoom={6}
                        style={mapStyles}
                        initialCenter={this.state.initialCenter}>

                        {this.displayMarkers()}

                        <InfoWindow
                            marker={this.state.activeMarker}
                            visible={this.state.showingInfoWindow}
                            onClose={this.onClose}
                        >
                            <div>
                                <h4>{this.state.activeMarker.name}</h4>
                            </div>
                        </InfoWindow>
                    </GMaps>
                </div>
            </div>
        }
    }

    displayDataColheita = (productTraceability) => {
        if (productTraceability.harvestDate != null) {
            return <h6 className="panel-title">
                Data de Colheita: {this.formatDate(new Date(productTraceability.harvestDate))}
            </h6>
        }
    }

    displayProductValidity = (productTraceability) => {
        if (productTraceability.validity != null) {
            return <h6 className="panel-title">
                Validade: {productTraceability.validity}
            </h6>
        }
    }

    formatDate = (date) => {
        var monthNames = [
            "Janeiro", "Fevereiro", "Março",
            "Abril", "Maio", "Junho", "Julho",
            "Agosto", "Setembro", "Outubro",
            "Novembro", "Dezembro"
        ];

        var day = date.getDate();
        var monthIndex = date.getMonth();
        var year = date.getFullYear();

        return day + ' de ' + monthNames[monthIndex] + ' ' + year;
    }

    handleTraceabilityCodeChange = (event) => {
        this.setState({ traceabilityCode: event.target.value });
    }

    onRetailChanged = (event) => {
        this.setState({ retail: event.target.value });
        var retails = this.state.retailsList.filter(retail => retail
            .data().customerId === event.target.value);

        retails.sort((a, b) => new Date(a.data().consolidationDate) - new Date(b.data().consolidationDate));
        const data = retails[retails.length - 1].data();
        
        this.setState({
            product: data,
            showRetails: false,
            initialCenter: { lat: data.merchantLat, lng: data.merchantLong },
        });
    }

    handleSubmit = (event) => {

        const search = queryString.parse(this.props.search)

        if (this.state.traceabilityCode !== null && this.state.traceabilityCode.trim() !== '')
            traceability_service.fetchMerchantProductTraceabilityCode(search.m, this.state.traceabilityCode, (data) => {
                if (data != null)
                    this.setState({
                        product: data,
                        initialCenter: { lat: data.merchantLat, lng: data.merchantLong },
                        showForm: false
                    })
                else {
                    alert('Código de rastreabilidade inválido');
                }
            });
        else {
            alert('Código de rastreabilidade obrigatório');
        }
    }
}

export default GoogleApiWrapper({
    apiKey: 'AIzaSyAiw0Mb4wItEBy1Z8NQEgF7PNUqYdHu8sg'
})(MerchantTraceability);